module.exports = __webpack_public_path__ + "img/redpoint.fa18596a.svg";